var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "25px",
    viewBox: "0 0 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace---Scan-List",
    transform: "translate(-239.000000, -391.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.78378,391 C248.139146,391 247.523248,391.254752 247.066892,391.711108 L246.531125,392.246875 L240.29675,392.246875 C239.847082,392.240516 239.428824,392.476768 239.202134,392.865166 C238.975444,393.253565 238.975444,393.733935 239.202134,394.122334 C239.428824,394.510732 239.847082,394.746984 240.29675,394.740625 L260.24675,394.740625 C260.696418,394.746984 261.114676,394.510732 261.341366,394.122334 C261.568056,393.733935 261.568056,393.253565 261.341366,392.865166 C261.114676,392.476768 260.696418,392.240516 260.24675,392.246875 L254.012375,392.246875 L253.476608,391.711108 C253.021498,391.254752 252.404354,391 251.75972,391 L248.78378,391 Z M240.752152,397.234375 L242.656558,413.772516 C242.821146,415.006922 243.884009,415.9375 245.128391,415.9375 L255.412674,415.9375 C256.657055,415.9375 257.721107,415.008402 257.886942,413.762774 L259.791349,397.234375 L240.752152,397.234375 Z",
    id: "Delete"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bdbfc34bc7a9f5dd36b999631e535985.svg";
export { ForwardRef as ReactComponent };